import { CATEGORY_ID_CORAL } from '../config/r2rListingTypeCategories';
import {
  PROFILE_LISTINGS_CATEGORIES,
  PROFILE_LISTINGS_CATEGORY_CORALS,
} from './profileListingsQuery';

export const getCoralChildren = categoryConfiguration => {
  const categories = categoryConfiguration?.categories || [];
  const coral = categories.find(c => c.id === CATEGORY_ID_CORAL);
  return (coral?.subcategories || [])
    .filter(child => child?.id && child?.name)
    .map(({ id, name }) => ({ id, name }));
};

export const profileListingsVisibility = ({
  typeCounts = {},
  childCounts = {},
  category,
  totalItems = 0,
}) => {
  const topOptions = PROFILE_LISTINGS_CATEGORIES.filter(key => (typeCounts[key] || 0) > 0).map(
    key => ({ key, count: typeCounts[key] })
  );
  const coralOptions = Object.keys(childCounts)
    .filter(key => childCounts[key] > 0)
    .map(key => ({ key, count: childCounts[key] }));

  const showTopDropdown = topOptions.length >= 2;
  const onlyCorals = !showTopDropdown && topOptions.length === 1 && topOptions[0].key === 'corals';
  const onCorals = category === PROFILE_LISTINGS_CATEGORY_CORALS || onlyCorals;
  const showCoralDropdown = onCorals && coralOptions.length >= 2;

  return {
    showTopDropdown,
    showCoralDropdown,
    showSort: totalItems >= 2,
    topOptions,
    coralOptions,
  };
};
